var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 10.783a.7.7 0 0 1-.279-.054.8.8 0 0 1-.26-.18L4.2 7.29A.68.68 0 0 1 4 6.747a.77.77 0 0 1 .217-.522.7.7 0 0 1 .54-.226.75.75 0 0 1 .522.226L8 8.964l2.739-2.738a.7.7 0 0 1 .513-.217q.297 0 .532.235a.72.72 0 0 1 .216.531q0 .315-.216.531L8.54 10.55a.8.8 0 0 1-.261.18.7.7 0 0 1-.28.054"
  })));
};
export default SvgChevronDown;